<template>
  <div
    v-if="critereRecherche"
    class="columns is-multiline is-marginless is-main-content is-paddingless">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 is-marginless overflow-auto hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="critereRecherche.datesEcheance"
            :label="$t('detailMarche.ventesMarche.filtre.periodeAnalyse')">
          </input-periode>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('detailMarche.ventesMarche.filtre.planMedia')">
            <qd-taginput
              v-model="planMediaSelected"
              :data="filteredPlanMedia"
              :loading="isFetchingPlanMedia"
              icon="magnify"
              type="is-primary"
              field="code"
              autocomplete
              @typing="getfilteredPlanMedia">
              <template slot-scope="props">
                {{ props.option.code }}
              </template>
              <template slot="empty">
                <div v-if="!isFetchingPlanMedia">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('detailMarche.ventesMarche.filtre.codeCmd')">
            <b-input v-model="critereRecherche.code">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('detailMarche.ventesMarche.filtre.produits')">
            <qd-taginput
              v-model="produitsSelected"
              icon="magnify"
              :data="filteredProduits"
              autocomplete
              type="is-primary"
              :loading="isFetchingProduits"
              field="reference"
              @typing="getfilteredProduits">
              <template slot-scope="props">
                {{ props.option.reference }} - {{ props.option.libelle }}
              </template>
              <template slot="empty">
                <div v-if="!isFetchingProduits">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <query-client-tag-input
            v-model="payeursSelected"
            :label="$t('detailMarche.ventesMarche.filtre.payeurs')"
            :societeActiveId="societeActiveId">
          </query-client-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-client-tag-input
            v-model="annonceursSelected"
            :label="$t('detailMarche.ventesMarche.filtre.annonceurs')"
            :societeActiveId="societeActiveId">
          </query-client-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('detailMarche.ventesMarche.filtre.afficherDevis')">
            <b-select v-model="critereRecherche.afficherDevis">
              <option :value="true"> {{ $t('general.oui') }} </option>
              <option :value="false"> {{ $t('general.non') }} </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.apply')}}
      </button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('general.button.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import { getAll as getAllPlanMedia } from '@/api/planMedia';
import { getAll as getAllProduits } from '@/api/produit';
import { SET_CRITERE_RECHERCHE_VENTES_MARCHE } from '@/store/modules/achat/marche-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { genererCritereRechercheListeVente } from '@/services/achat/marche/genererCritereRecherche';
import inputPeriode from '@/components/general/inputPeriode';
import queryClientTagInput from '@/components/general/tagInput/queryClientTagInput';
import * as produitConf from '@/configuration/catalogue/produitConf';

const Marche = createNamespacedHelpers('marche');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'FilterVetesMarche',
  components: {
    inputPeriode,
    queryClientTagInput,
  },
  data() {
    return {
      critereRecherche: null,
      planMediaSelected: [],
      filteredPlanMedia: [],
      isFetchingPlanMedia: false,
      produitsSelected: [],
      filteredProduits: [],
      isFetchingProduits: false,
      payeursSelected: [],
      annonceursSelected: [],
    };
  },
  computed: {
    ...Marche.mapGetters({
      critereRechercheFromStore: 'criteresRechercheVentesMarche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    ...Marche.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE_VENTES_MARCHE,
    }),
    getfilteredPlanMedia: debounce(async function getPlanMedia(search) {
      this.filteredPlanMedia = [];
      if (!search) return;
      this.isFetchingPlanMedia = true;
      try {
        const planMedia = (await getAllPlanMedia({
          query: {
            code: search,
            societeId: this.societeActiveId,
          },
        })).data.result.items;
        this.filteredPlanMedia = planMedia.filter((el) => {
          return !this.planMediaSelected.map(p => p.id).includes(el.id);
        });
        this.isFetchingPlanMedia = false;
      } catch (e) {
        this.isFetchingPlanMedia = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getfilteredProduits: debounce(async function getProduits(search) {
      this.filteredProduits = [];
      if (!search) return;
      this.isFetchingProduits = true;
      try {
        const produits = (await getAllProduits({
          query: {
            auto: search,
            categorie: [
              produitConf.CATEGORIE_PRESSE,
              produitConf.CATEGORIE_SPONSORING,
              produitConf.CATEGORIE_SALON,
              produitConf.CATEGORIE_AUTRE,
            ],
          },
        })).data.result.items;
        this.filteredProduits = produits.filter((produit) => {
          return !this.produitsSelected.map(
            produitSelected => produitSelected.id,
          ).includes(produit.id);
        });
        this.isFetchingProduits = false;
      } catch (e) {
        this.isFetchingProduits = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    viderCritere() {
      this.planMediaSelected = [];
      this.produitsSelected = [];
      this.payeursSelected = [];
      this.annonceursSelected = [];
      this.critereRecherche = cloneDeep(genererCritereRechercheListeVente());
    },
    appliquerCritere() {
      this.critereRecherche.planMediaIds = this.planMediaSelected;
      this.critereRecherche.produitsIds = this.produitsSelected;
      this.critereRecherche.payeurs = this.payeursSelected;
      this.critereRecherche.annonceurs = this.annonceursSelected;
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    initializeFiltre() {
      this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
